<template>
  <div class="ad-container">
    <div class="padding-lr-16">
      <p>发票详情</p>
      <div class="ad-body-box">
        <div class="flex justify-between">
          <p class="margin-left-16 text-grey">抬头类型</p>
          <p>
            <van-radio-group v-model="titleType" class="flex justify-between">
              <van-radio name="0">企业单位</van-radio>
              <van-radio name="1">个人/非企业</van-radio>
            </van-radio-group>
          </p>
        </div>
        <van-field
          v-model="recordInfo.name"
          label="发票抬头"
          input-align="right"
          placeholder="请填写发票抬头"
          :rules="rules.name"
        />
        <div v-if="titleType == 0">
          <van-field
            v-model="recordInfo.taxNumber"
            label="税号"
            input-align="right"
            placeholder="请填写税号"
            :rules="rules.taxNumber"
          />
        </div>
        <div class="flex justify-between">
          <p class="margin-left-16 text-grey">更多信息</p>
          <p @click="showPopup()">备注信息（非必填）></p>
        </div>
      </div>
      <div>
        <h4>注意事项：</h4>
        <p>1.请仔细核对填写的发票信息，以免在此修改</p>
        <p>
          2.按照新的发票信息重开发票后，旧抬头对应的发票将被作废，无法进行报销,
          新抬头的发票将会推送到您上次开票的邮箱中
        </p>
      </div>
      <div>
        <van-button
          v-if="titleType == 0"
          class="button"
          type="warning"
          @click="submitInfo('0')"
          >提交</van-button
        >
        <van-button
          v-if="titleType == 1"
          class="button"
          type="warning"
          @click="submitInfo('1')"
          >提交</van-button
        >
      </div>
      <van-popup
        v-model="show"
        position="bottom"
        close-icon="close"
        round
        closeable
        :style="{ height: '54%' }"
      >
        <div class="distance-select">
          <div class="infotitle text-14 bg-title margin-top-30">更多信息</div>
          <div>
            <van-cell-group>
              <van-field
                v-model="recordInfo.remark"
                label="备注说明"
                placeholder="填写备注说明"
              />
              <van-field
                v-model="recordInfo.address"
                label="注册地址"
                placeholder="填写注册地址"
              />
              <van-field
                v-model="recordInfo.mobile"
                label="注册电话"
                placeholder="填写注册电话"
              />
              <van-field
                v-model="recordInfo.openBank"
                label="开户银行"
                placeholder="填写开户银行"
              />
              <van-field
                v-model="recordInfo.openBankNumber"
                label="银行账号"
                placeholder="填写银行账号"
              />
            </van-cell-group>
          </div>
          <van-button class="btnTwo" @click="downLoad()">确认</van-button>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { applyInvoice } from 'api/invoice'
export default {
  data () {
    return {
      recordInfo: {
        name: '',
        taxNumber: ''
      },
      titleType: '',
      getUpDetail: {
        remark: ''
      },
      checked: true,
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      radio: '1',
      value: '',
      show: false,
      upDetailId: '',
      rules: {
        name: [
          {
            required: true,
            message: '请填写发票抬头',
            trigger: 'onBlur'
          }
        ],
        taxNumber: [
          {
            required: true,
            message: '税号必须为7-20位数字或大写字母',
            trigger: 'onBlur'
          }
        ]
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // upDetail () {
    //   this.upDetailId = JSON.parse(window.localStorage.getItem('upDetailId'))
    //   var data = {
    //     id: this.upDetailId.id
    //   }
    //   getUpDetail(data)
    //     .then(res => {
    //       this.getUpDetail = res
    //       console.log('ahhahhahah', this.getUpDetail)
    //     })
    //     .catch(() => {})
    //     .finally(() => {})
    // },
    getList () {
      // 获取发票详情
      this.recordInfo = JSON.parse(window.localStorage.getItem('detailInfo'))
      this.titleType = this.recordInfo.titleType + ''
      console.log('detailInfo', this.recordInfo)
    },
    submitInfo (type) {
      var data
      var orderDetails = JSON.parse(window.localStorage.getItem('detail'))
      var _orderDetails = []
      for (var i in orderDetails) {
        var _data = orderDetails[i]
        var _item = {}
        _item.name = _data.lineName
        _item.sn = _data.orderId
        _item.priceIncludingTax = _data.realPayMoney
        _orderDetails.push(_item)
      }
      if (type === '0') {
        if (!this.recordInfo.name) {
          this.$toast('请填写发票抬头')
        } else if (!this.recordInfo.taxNumber) {
          this.$toast('请填写公司税号')
        } else {
          this.$dialog
            .confirm({
              title: '确认重开发票',
              message:
                '发票只能重开一次，重新申请提交后原发票将会作废，无法进行报销，请谨慎选择'
            })
            .then(() => {
              data = {
                invoiceId: this.recordInfo.id,
                titleType: this.titleType,
                name: this.recordInfo.name,
                taxNumber: this.recordInfo.taxNumber,
                email: this.recordInfo.email,
                content: '客运服务费 ',
                issueType: 1,
                remark: this.recordInfo.remark,
                address: this.recordInfo.address,
                mobile: this.recordInfo.mobile,
                openBank: this.recordInfo.openBank,
                openBankNumber: this.recordInfo.openBankNumber,
                orderDetails: _orderDetails
              }
              applyInvoice(data).then(res => {
                this.applyInvoice = res
                this.$toast('申请重开发票成功')
                this.$router.replace('/invoice/progress')
              })
            })
        }
      }
      if (type === '1') {
        if (!this.recordInfo.name) {
          this.$toast('请填写发票抬头')
        } else {
          this.$dialog
            .confirm({
              title: '确认重开发票',
              message:
                '发票只能重开一次，重新申请提交后原发票将会作废，无法进行报销，请谨慎选择'
            })
            .then(() => {
              data = {
                invoiceId: this.recordInfo.id,
                titleType: this.titleType,
                name: this.recordInfo.name,
                email: this.recordInfo.email,
                content: '客运服务费 ',
                issueType: 1,
                remark: this.recordInfo.remark,
                address: this.recordInfo.address,
                mobile: this.recordInfo.mobile,
                openBank: this.recordInfo.openBank,
                openBankNumber: this.recordInfo.openBankNumber,
                orderDetails: _orderDetails
              }
              applyInvoice(data).then(res => {
                this.applyInvoice = res
                this.$toast('申请重开发票成功')
                this.$router.replace('/invoice/progress')
              })
            })
        }
      }
    },
    showPopup () {
      this.show = true
    },
    downLoad () {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.infotitle {
  padding: 8px;
}
.ad-body-box {
  background-color: #fff;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0 0 12px 0 #eee;
  padding: 0 8px;
}
.titleTwo {
  margin-top: -14px;
}
.notice {
  margin-top: 16px;
}
.bg-title {
  background-color: #fbd3926b;
  width: 100%;
}
.distance {
  margin-top: 20px;
}
.list {
  margin-top: 17px;
}
.button {
  border-radius: 50px;
  width: 90%;
  margin-top: 20px;
  background-color: #ff7307;
  margin-left: 16px;
}
.btn {
  border-radius: 50px;
  width: 90%;
  margin-top: 60%;
  background-color: #ff7307;
  margin-left: 12px;
}
.distance-select {
  padding: 10px;
}
.btnTwo {
  border-radius: 50px;
  width: 90%;
  margin-top: 20%;
  background-color: #ff7307;
  margin-left: 12px;
  color: #fff;
  position: fixed;
  text-align: center;
  z-index: 999;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
